import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { MEDIA } from "../lib/api";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState({});

    const load = useCallback(async () => {
        try {
            const res = await api.get("/settings/public");
            setSettings(res.data || {});
        } catch {}
    }, []);

    useEffect(() => { load(); }, [load]);

    // Sync <title> and <link rel="icon"> with settings
    useEffect(() => {
        if (settings.site_title) {
            document.title = settings.site_title;
        } else if (settings.site_name) {
            document.title = settings.site_name;
        }
        if (settings.favicon_url) {
            const href = settings.favicon_url.startsWith("http") ? settings.favicon_url : MEDIA(settings.favicon_url);
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement("link");
                link.rel = "icon";
                document.head.appendChild(link);
            }
            link.href = href;
        }
    }, [settings.site_title, settings.site_name, settings.favicon_url]);

    return (
        <SettingsContext.Provider value={{ settings, reload: load }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => useContext(SettingsContext);
